import * as constants from './constants';
import controller from './controller';
import { store } from '../../../lib/redux';

const dispatchFail = (dispatch, failType, error) => {
  dispatch({ type: failType, payload: { loading: false, error } });

  throw error;
};

export function resetError() {
  return {
    type: constants.RESET_ERROR,
    payload: { error: null },
  };
}

export function getUsersList(params) {
  return dispatch => controller.getUserList(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_USERS_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_USERS_SUCCESS,
      payload: { list: response.data, error: undefined },
    });
  });
}

export function getUserInfo(userId) {
  return dispatch => controller.getUser(userId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_USER_SUCCESS,
      payload: { item: response.data, error: undefined },
    });
  });
}

export function createUser(data) {
  return dispatch => controller.createUser(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.CREATE_USER_SUCCESS,
      payload: { newUser: response.data, error: undefined },
    });
  });
}

export function updateUser(data) {
  return dispatch => controller.updateUser(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.UPDATE_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.UPDATE_USER_SUCCESS,
      payload: { error: undefined },
    });
  });
}

// Повторная отправка инвайта
export function reinviteUser(data) {
  return dispatch => controller.reinviteUser(data).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.REINVITE_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.REINVITE_USER_SUCCESS,
      payload: { error: undefined },
    });
  });
}

// разлогин пользователя в партнёрской прилаге
export function deletePartnerAppLogin(userId) {
  return dispatch => controller.deletePartnerAppLogin(userId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_USER_PARTNER_APP_LOGIN_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.DELETE_USER_PARTNER_APP_LOGIN_SUCCESS,
      payload: { error: undefined },
    });
  });
}

export function getAvatar(userId) {
  return dispatch => {
    dispatch({
      type: constants.GET_USER_AVATAR,
      payload: { avatar: '', avatarError: undefined },
    });

    return controller.getAvatar(userId).then(response => {
      if (response.errorData) {
        return dispatch({
          type: constants.GET_USER_AVATAR_FAIL,
          payload: {
            avatar: '',
            avatarError: response.errorData,
          },
        });
      }

      const reader = new FileReader();

      reader.readAsDataURL(response.data);
      reader.onloadend = () => dispatch({
        type: constants.GET_USER_AVATAR_SUCCESS,
        payload: {
          avatar: reader.result,
          avatarError: undefined,
        },
      });
    });
  };
}

export function setAvatar(userId, file) {
  return dispatch => controller.setAvatar(userId, file).then(response => {
    if (response.errorData) {
      return dispatch({ type: constants.SET_USER_AVATAR_FAIL, payload: { avatarError: response.errorData } });
    }

    return dispatch({
      type: constants.SET_USER_AVATAR_SUCCESS,
      payload: { avatarError: undefined },
    });
  });
}

// блок привязки пользователей к офисам партнёра
export function getUserOffices(userId) {
  return dispatch => controller.getUserOffices(userId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.FETCH_OFFICE_USER_FAIL, response.errorData);
    }

    return dispatch({
      type: constants.FETCH_OFFICE_USER_SUCCESS,
      payload: { offices: response.data.items, officesUserId: userId, error: null },
    });
  });
}

export function createUserOffice(params) {
  return dispatch => controller.createUserOffice(params).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.CREATE_OFFICE_USER_FAIL, response.errorData);
    }

    return dispatch({ type: constants.CREATE_OFFICE_USER_SUCCESS, payload: { error: null } });
  });
}

export function deleteUserOffice(userOfficeId) {
  return dispatch => controller.deleteUserOffice(userOfficeId).then(response => {
    if (response.errorData) {
      return dispatchFail(dispatch, constants.DELETE_OFFICE_USER_FAIL, response.errorData);
    }

    return dispatch({ type: constants.DELETE_OFFICE_USER_SUCCESS, payload: { error: null } });
  });
}

export function updateUserOfficesInRedux(offices) {
  return dispatch => dispatch({
    type: constants.UPDATE_OFFICE_USER_REDUX,
    payload: { offices, error: undefined },
  });
}

// конец блока привязки пользователей к офисам партнёра

export function checkEmail(data) {
  // проверим, может только что проверяли такой Email
  // TODO - тут ещё бы здоровов сделать, чтоб Email считался уникальным в течении некоторого времени.
  // например, 5-10 секунд
  const cacheValueLastCheckedEmail = store.getState().users.lastCheckedEmail;
  const cacheValueLastCheckedEmailResponse = store.getState().users.lastCheckedEmailResponse;

  if (cacheValueLastCheckedEmail === data?.email) {
    // getLastCheckEmail - возращает промис с данными. Нельзя тут просто вернуть данные.
    // "Потребители" ожидают Промис. Пришлось такую функцию сделать.
    return dispatch => controller.getLastCheckEmail(cacheValueLastCheckedEmailResponse).then(response => {
      return dispatch({
        type: constants.CHECK_EMAIL_SUCCESS,
        payload: { lastCheckedEmailResponse: response, error: null },
      });
    });
  }

  return dispatch => {
    dispatch({
      type: constants.CHECK_EMAIL,
      payload: { lastCheckedEmail: data?.email, lastCheckedEmailResponse: undefined, error: undefined },
    });

    return controller.checkEmail(data).then(response => {
      if (response.errorData) {
        return dispatchFail(dispatch, constants.CHECK_EMAIL_FAIL, response.errorData);
      }
      return dispatch({
        type: constants.CHECK_EMAIL_SUCCESS,
        payload: { lastCheckedEmailResponse: response.data, lastCheckedEmail: data?.email, error: null },
      });
    });
  };
}
